import { ValueTypeEnum } from '../value-type-enum.model';

export class FormElementProfileField {
  // #region Properties

  public Id: number;
  public LabelText: string;
  public HelpText: string;
  public Visible: boolean;

  // #endregion

  public constructor() {
    this.Id = 0;
    this.LabelText = '';
    this.HelpText = '';
    this.Visible = false;
  }
}
